import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/parts-catalog/checkout")({
  component: () => <Outlet />,
});
